'use client';
import { safeSanitize } from '@/core/utils/sanitize';

interface HtmlContentProps {
  html: string;
  className?: string;
  style?: React.CSSProperties;
}

export function HtmlContent({ html, className, style }: HtmlContentProps) {
  return (
    <div
      className={className}
      style={style}
      dangerouslySetInnerHTML={{ __html: safeSanitize(html) }}
    />
  );
}
